export default [
  { id: 1, name: 'ATIVAR SAÍDA 1' },
  { id: 2, name: 'DESATIVAR SAÍDA 1' },
  { id: 3, name: 'DESATIVAR PÂNICO' },
  { id: 4, name: 'ATIVAR SAÍDA 2' },
  { id: 5, name: 'DESATIVAR SAÍDA 2' },
  { id: 6, name: 'DEFINIR ODÔMETRO' },
  { id: 8, name: 'SEM TEMPLATE' },
  { id: 9, name: 'SEM TEMPLATE (LOTE)' },
]
